<span class="portfolio-start-text" *ngIf="max_start_date && selected.length" [hidden]="hideStartDateText">
  Earliest possible start date: <span class="font-weight-bold">{{max_start_date}}</span>
</span>
<div *ngIf="currentTab < 3" class="search">
  <div class="flex">
    <app-new-portfolio-search [model]="currentFilters.searchTerm" (fetchCompanies)="onFetchCompanies()" (modelChange)="currentFilters.searchTerm = $event" [meta]="meta"> </app-new-portfolio-search>
    <div class="small mt-1 ms-4">
      <button (click)="toggle()" matIconButton color="primary"><mat-icon>filter_list</mat-icon></button>
    </div>
  </div>
</div>
<div class="filters-sidenav-content">
  <mat-tab-group mat-align-tabs="start" (selectedTabChange)="onTabChange($event)" [selectedIndex]="currentTab">
    <mat-tab label="Equity Selection" [disabled]="loading">
      <app-new-portfolio-active-sorting
        [selected]="selected"
        [selectedFilterLabels]="selectedFilterLabels"
        [filter_label_length_limit]="filter_label_length_limit"
        [currentFilters]="currentFilters"
        [sorting]="sorting"
        [checked]="checkedOnly"
        [onCheckChange]="onCheckChange"
        (selectAllClick)="onSelectAllCompany($event)"
        (deleteFilterClick)="onDeleteFilterClick($event)"
        (deleteDynamicFilterClick)="onDeleteDynamicFilterClick($event)"
        (deleteSortClick)="onDeleteSortClick($event)"
      ></app-new-portfolio-active-sorting>

      <div class="mat-elevation-z8 mt-4 pb-1">
        <div class="card mt-4 mb-4">
          <div class="card-body p-0" style="overflow: hidden;">
            <app-asset-table
              *ngIf="assetType == 'stock'"
              [list]="mergedItems"
              [columnVisibility]="columnVisibility"
              [filterLists]="filterLists"
              [sorting]="sorting"
              [currentFilters]="currentFilters"
              [quantList]="dynamicColumns"
              filterProp="quant"
              (itemSelect)="onSelect($event)"
              (fetchCompanies)="onFetchCompanies()"
              (sortClicked)="onSortClick($event)"
            ></app-asset-table>
          </div>
          <app-pagination *ngIf="list.length" [meta]="meta" (pageEvent)="onPageEvent($event)"></app-pagination>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Fund Selection" [disabled]="loading">
      <app-new-portfolio-active-sorting
        [selected]="selected"
        [selectedFilterLabels]="selectedFilterLabels"
        [filter_label_length_limit]="filter_label_length_limit"
        [currentFilters]="currentFilters"
        [sorting]="sorting"
        [checked]="checkedOnly"
        [onCheckChange]="onCheckChange"
        (selectAllClick)="onSelectAllCompany($event)"
        (deleteFilterClick)="onDeleteFilterClick($event)"
        (deleteDynamicFilterClick)="onDeleteDynamicFilterClick($event)"
        (deleteSortClick)="onDeleteSortClick($event)"
      ></app-new-portfolio-active-sorting>

      <div class="mat-elevation-z8 mt-4 pb-1">
        <div class="card mt-4 mb-4">
          <div class="card-body p-0" style="overflow: hidden;">
            <app-asset-table
              *ngIf="assetType == 'fund'"
              [list]="mergedItems"
              [columnVisibility]="columnVisibility"
              [filterLists]="filterLists"
              [sorting]="sorting"
              [currentFilters]="currentFilters"
              [quantList]="dynamicColumns"
              filterProp="fund_reference_table"
              (itemSelect)="onSelect($event)"
              (fetchCompanies)="onFetchCompanies()"
              (sortClicked)="onSortClick($event)"
            ></app-asset-table>
          </div>
          <app-pagination *ngIf="list.length" [meta]="meta" (pageEvent)="onPageEvent($event)"></app-pagination>
        </div>
      </div>
    </mat-tab>



    <mat-tab label="ETF Selection" [disabled]="loading">
      <!-- <app-new-portfolio-search [model]="currentFilters.searchTerm" (fetchCompanies)="onFetchCompanies()" (modelChange)="currentFilters.searchTerm = $event" [meta]="meta"> </app-new-portfolio-search> -->
      <!-- <app-asset-table-column-visibility-filter #etfFilters [columnVisibility]="columnVisibility" assetType="etf" [quantList]="quantList" [dynamicColumns]="dynamicColumns" (columnChanged)="onDynamicColumnChange($event)"></app-asset-table-column-visibility-filter> -->
      <app-new-portfolio-active-sorting
        [selected]="selected"
        [selectedFilterLabels]="selectedFilterLabels"
        [filter_label_length_limit]="filter_label_length_limit"
        [currentFilters]="currentFilters"
        [sorting]="sorting"
        [checked]="checkedOnly"
        [onCheckChange]="onCheckChange"
        (selectAllClick)="onSelectAllCompany($event)"
        (deleteFilterClick)="onDeleteFilterClick($event)"
        (deleteDynamicFilterClick)="onDeleteDynamicFilterClick($event)"
        (deleteSortClick)="onDeleteSortClick($event)"
      ></app-new-portfolio-active-sorting>
      <div class="mat-elevation-z8 mt-4 pb-1">
        <div class="card mb-4">
          <div class="card-body p-0 overflow-hidden">
            <div class="row">
              <div class="col-md-3">
                <app-sidebar-filter [currentFilters]="currentFilters" [filterLists]="filterLists" (onFilterEvent)="onFetchCompanies()" (onResetFilterEvent)="resetFilters()"></app-sidebar-filter>
              </div>
              <div class="col-md-9">
                <app-asset-table
                *ngIf="assetType == 'etf'"
                [list]="mergedItems"
                [columnVisibility]="columnVisibility"
                [filterLists]="filterLists"
                [sorting]="sorting"
                [currentFilters]="currentFilters"
                [quantList]="dynamicColumns"
                filterProp="etf_reference_table"
                [widerFirstCol]="true"
                (itemSelect)="onSelect($event)"
                (fetchCompanies)="onFetchCompanies()"
                (sortClicked)="onSortClick($event)"
              ></app-asset-table>
              </div>
            </div>
          </div>
          <app-pagination *ngIf="list.length" [meta]="meta" (pageEvent)="onPageEvent($event)"></app-pagination>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Overview" [disabled]="loading || !selected.length">
      <div>
          <app-new-portfolio-select-dialog [portfolio]="portfolio" [list]="selected" (itemRemove)="onSelect($event)"></app-new-portfolio-select-dialog>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
